// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import xOrderInformationStyles from "@guestsupply/App/SharedStyles/MyAccountPages/Details/OrderInformationStyles";
import { savedOrderDetailsOrderInformationStyles } from "@guestsupply/Overrides/Widgets/SavedOrderDetails/SavedOrderDetailsOrderInformation";
import { mergeWithCss } from "@guestsupply/XDL/Utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

savedOrderDetailsOrderInformationStyles.orderDateTitle = {
    ...xOrderInformationStyles.labelWithDots,
};
savedOrderDetailsOrderInformationStyles.orderDateText = {
    ...xOrderInformationStyles.value,
};
savedOrderDetailsOrderInformationStyles.shippingAddressTitle = {
    ...mergeWithCss(xOrderInformationStyles.address?.heading, {
        css: css`
            padding-bottom: 4px;
            margin-bottom: 0px;
        `,
    }),
};
savedOrderDetailsOrderInformationStyles.billingAddressTitle = {
    ...mergeWithCss(xOrderInformationStyles.address?.heading, {
        css: css`
            padding-bottom: 4px;
            margin-bottom: 0px;
        `,
    }),
};

savedOrderDetailsOrderInformationStyles.mainInformationGridItem = {
    width: 12,
    css: css`
        flex-direction: row;
    `,
};
savedOrderDetailsOrderInformationStyles.divider = {
    ...mergeWithCss(xOrderInformationStyles?.address?.divider, {
        css: css`
            &&& {
                border-top: 1px solid ${getColor("common.border")};
                margin: 8px 0 12px 0;
                padding: 0;
                width: 100%;
                max-height: 0px;
            }
        `,
    }),
};
